export const sizeStyle = {
  md: {
    height: '24px',
    font: 'var(--text-xs-bold)',
    iconSize: 'xs'
  },
  lg: {
    height: '32px',
    font: 'var(--text-sm-bold)',
    iconSize: 'sm'
  },
  xl: {
    height: '40px',
    font: 'var(--text-md-bold)',
    iconSize: 'md'
  }
};
export const kindStyle = {
  default: {
    background: 'var(--neutral-surface-low-emphasis)',
    backgroundHover: 'var(--neutral-surface-hover)',
    color: 'var(--neutral-text-high-emphasis)',
    colorHover: 'var(--neutral-text-high-emphasis)',
    fill: 'var(--neutral-icon-high-emphasis)',
    fillHover: 'var(--neutral-icon-high-emphasis)'
  },
  primary: {
    background: 'var(--primary-surface-low-emphasis)',
    backgroundHover: 'var(--primary-surface-hover)',
    color: 'var(--neutral-text-high-emphasis)',
    colorHover: 'var(--neutral-text-high-emphasis)',
    fill: 'var(--neutral-icon-high-emphasis)',
    fillHover: 'var(--neutral-icon-high-emphasis)'
  },
  success: {
    background: 'var(--success-surface-low-emphasis)',
    backgroundHover: 'var(--success-surface-hover)',
    color: 'var(--neutral-text-high-emphasis)',
    colorHover: 'var(--neutral-text-high-emphasis)',
    fill: 'var(--neutral-icon-high-emphasis)',
    fillHover: 'var(--neutral-icon-high-emphasis)'
  },
  danger: {
    background: 'var(--danger-surface-low-emphasis)',
    backgroundHover: 'var(--danger-surface-hover)',
    color: 'var(--neutral-text-high-emphasis)',
    colorHover: 'var(--neutral-text-high-emphasis)',
    fill: 'var(--neutral-icon-high-emphasis)',
    fillHover: 'var(--neutral-icon-high-emphasis)'
  },
  warning: {
    background: 'var(--warning-surface-low-emphasis)',
    backgroundHover: 'var(--warning-surface-hover)',
    color: 'var(--neutral-text-high-emphasis)',
    colorHover: 'var(--neutral-text-high-emphasis)',
    fill: 'var(--neutral-icon-high-emphasis)',
    fillHover: 'var(--neutral-icon-high-emphasis)'
  },
  help: {
    background: 'var(--highlight-surface-low-emphasis)',
    backgroundHover: 'var(--highlight-surface-hover)',
    color: 'var(--neutral-text-high-emphasis)',
    colorHover: 'var(--neutral-text-high-emphasis)',
    fill: 'var(--neutral-icon-high-emphasis)',
    fillHover: 'var(--neutral-icon-high-emphasis)'
  }
};